<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card height="100%">
        <v-card-title
          class="headline indigo darken-4 white--text fixed-header"
          primary-title
        >
          {{ $vuetify.t('$vuetify.calls.signInMethod').toUpperCase() }}
        </v-card-title>

        <v-card-text>
          <div v-if="method" class="signin-instructions ma-0 pa-2">
            <span class="d-block">{{ method }}</span>
            <a v-if="link" :href="link" target="_blank">Click here</a>
          </div>

          <div v-else class="signin-instructions ma-0 pa-2">
            <span class="d-block"
              ><i>{{ $vuetify.t('$vuetify.calls.noSignInMethod') }}</i></span
            >
          </div>
        </v-card-text>

        <div class="footer text-xs-center mb-3">
          <v-divider></v-divider>
          <v-card-text>
            <v-btn @click="back()">
              {{ $vuetify.t('$vuetify.calls.back') }}
            </v-btn>

            <v-btn v-if="method" color="success" @click="confirmSignInMethod()">
              {{ $vuetify.t('$vuetify.calls.confirmSignInMethod') }}
            </v-btn>

            <v-btn v-else color="success" @click="confirmSignInMethod()">
              {{ $vuetify.t('$vuetify.calls.proceedToTheNextSection') }}
            </v-btn>
            <abort-visit v-on:aborted="visitAborted()" />
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AbortVisit from '@/components/AbortVisit.vue'

export default {
  props: ['show', 'method', 'link'],
  components: {
    AbortVisit
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    confirmSignInMethod() {
      this.dialog = false
      this.$emit('confirmed')
    },

    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },

    back() {
      this.dialog = false
      this.$emit('back')
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    }
  }
}
</script>

<style scoped>
.signin-instructions {
  border: thin solid #d0d0d0;
  min-height: 100px;
}

.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}
</style>
